export const _08ATitle = (): JSX.Element => {
  return (
    <div id="gallery" className="flex flex-col items-center justify-center relative mt-[-100px] pt-[100px]">
      <div className="flex flex-col w-[1400px] min-h-[591px] items-center justify-center pt-[100px] pb-[30px] px-[170px] relative flex-[0_0_auto]">
        <div className="flex flex-col items-center justify-center gap-[60px] relative self-stretch w-full flex-[0_0_auto]">
          <img
            className="relative w-[114px] h-[107px]"
            alt="Section title icon"
            src="/img/sectiontitleicon.svg"
          />

          <div className="flex flex-col items-center justify-center relative self-stretch w-full flex-[0_0_auto]">
            <div className="relative self-stretch mt-[-1.00px] [font-family:var(--section-title-font-family)] [font-size:var(--section-title-font-size)] [font-weight:var(--section-title-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--section-title-letter-spacing)] [line-height:var(--section-title-line-height)] [font-style:var(--section-title-font-style)]">
              Video Gallery
            </div>
          </div>

          <div className="flex flex-col items-center justify-center relative self-stretch w-full flex-[0_0_auto]">
            <p className="relative self-stretch mt-[-1.00px] [font-family:var(--section-description-font-family)] [font-size:var(--section-description-font-size)] [font-weight:var(--section-description-font-weight)] text-[var(--fy-grey)] text-center [letter-spacing:var(--section-description-letter-spacing)] [line-height:var(--section-description-line-height)] [font-style:var(--section-description-font-style)]">
              All packages now include our very popular forever online <br />
              gallery. Watch it on your Phone, Computer, or Smart TV.
            </p>
          </div>

          <div className="flex flex-col h-[28.89px] items-center justify-center relative self-stretch w-full">
            <div className="relative self-stretch mt-[-1.06px] [font-family:var(--section-divider-font-family)] [font-size:var(--section-divider-font-size)] [font-weight:var(--section-divider-font-weight)] text-[var(--fy-orange)] text-center [letter-spacing:var(--section-divider-letter-spacing)] [line-height:var(--section-divider-line-height)] [font-style:var(--section-divider-font-style)]">
              ........................................................................................................................................
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}; 